// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_1HeXMhoF855XpY3N6g8rO1"};